module.exports = __webpack_public_path__ + "static/media/radio_button_checked_blue.bc467315.svg";